import { render } from "./CreateAttachment.vue?vue&type=template&id=6ca7ac59"
import script from "./CreateAttachment.vue?vue&type=script&lang=js"
export * from "./CreateAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__